
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.793 3.793a1 1 0 011.414 0l2.145 2.145a1.5 1.5 0 010 2.121l-2.145 2.145a1 1 0 01-1.414-1.414l.794-.794h-2.322a3 3 0 00-2.573 1.457L12.164 12l1.528 2.547a3 3 0 002.573 1.457h2.322l-.794-.794a1 1 0 011.414-1.414l2.145 2.145a1.5 1.5 0 010 2.121l-2.145 2.145a1 1 0 01-1.414-1.414l.789-.79h-2.317a5 5 0 01-4.288-2.427l-.98-1.632-.974 1.625a5 5 0 01-4.288 2.427H3a1 1 0 110-2h2.735a3 3 0 002.573-1.456L9.832 12 8.308 9.46a3 3 0 00-2.573-1.456H3a1 1 0 110-2h2.735a5 5 0 014.288 2.427l.975 1.625.98-1.632a5 5 0 014.287-2.428h2.317l-.79-.789a1 1 0 010-1.414z"}})])
          )
        }
      }
    